import '@slightlyoff/lite-vimeo';
import { createApp, nextTick } from 'vue';
import HeaderComponent from './components/HeaderComponent.vue';
import CareerFilter from './components/CareerFilter.vue';

import GalleryApp from './components/GalleryApp.vue';
import GalleryGridApp from './components/GalleryGridApp.vue';
import './components/sliders.js';



// Vue component
const App = {
    data() {
      return {
        message: 'Hello Vue 3!'
      };
    },
    components: {
        HeaderComponent,
        CareerFilter,
        GalleryApp,
        GalleryGridApp
    
    }
  };

// Vue component
// const App = createApp({
//     components: {
//         Header
//     },
//     data() {
//         return {
//             message: 'Hello Vue 3!'
//         };
//     }
// });


// disable controlls on lite-vimeo
document.addEventListener('DOMContentLoaded', function () {

    // createApp(App).mount('#app');
    // Mount Vue app
    const app = createApp(App);
    app.mount('#app');
    nextTick(() => {
        document.dispatchEvent(new Event('vue:mounted'));
    });

    // Specific mount for the career filter section if needed
    // const careerFilterElement = document.querySelector('#career-filter-app');
    // if (careerFilterElement) {
    //     createApp(CareerFilter).mount(careerFilterElement);
    // }

    var contentBlocks = document.querySelectorAll('.content-block');
    if (contentBlocks) {
        // check if any of the contentBlocks children div  has a inline style , if so remove it
            contentBlocks.forEach(function (contentBlock) {
                var divs = contentBlock.querySelectorAll('div');
                if (divs) {
                    divs.forEach(function (div) {
                        if (div.hasAttribute('style')) {
                            div.removeAttribute('style');
                        }
                    });
                }
            }
        );
    }
    




});
